import { render, staticRenderFns } from "./AddModelCodeModal.vue?vue&type=template&id=274c42a6&"
import script from "./AddModelCodeModal.vue?vue&type=script&lang=js&"
export * from "./AddModelCodeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports